{
  "account": {
    "title": "Moj račun",
    "list": {
      "title": "Računi",
      "description": "Popis povezanih računa i faktura"
    },
    "form": {
      "name": {
        "title": "Ime",
        "description": "Ime vašeg računa"
      },
      "password": {
        "title": "Lozinka",
        "description": "Postavite novu lozinku za svoj račun, ostavite prazno za zadržavanje trenutne lozinke"
      },
      "emailPreferences": {
        "title": "Postavke e‑maila",
        "description": "Odaberite vrste obavijesti e‑mailom"
      }
    },
    "billing": "Podaci o naplatama",
    "subscriptions": "Pretplate",
    "manageSubscription": "Upravljanje pretplatom",
    "popup": {
      "cancel": "Jeste li sigurni da želite otkazati pretplatu? <br/>Vaša web stranica će se i dalje prevoditi do kraja trenutnog razdoblja pretplate. Nakon toga, prijevod će biti onemogućen.<br/>Napominjemo da nećete imati pravo na povrat za neiskorišteno razdoblje.",
      "downgrade": "Jeste li sigurni da želite smanjiti pretplatu? Smanjenje će stupiti na snagu odmah.<br/>Napominjemo da nećete imati pravo na povrat za preostalo vrijeme trenutnog obračunskog ciklusa.<br/>Cijena novog plana primijenit će se u sljedećem obračunskom ciklusu.",
      "default": "Jeste li sigurni da želite promijeniti plan?",
      "resume": "Jeste li sigurni da želite nastaviti pretplatu?"
    }
  },
  "ai_translation": {
    "header": "AI prijevod",
    "plan": {
      "header": "Cijene AI prijevoda",
      "used": "Iskoristili ste {words_used} / {words_allowed} prevedenih riječi u svojim AI kreditima.",
      "remaining": "Dostupni AI krediti:",
      "words": "riječi",
      "add_more_credits": "Dodajte još AI kredita",
      "details": {
        "idiomatic_expressions": "Idiomi i tehnički izrazi",
        "background_translation": "Prevođenje u pozadini",
        "best_website": "Web stranica koja zahtijeva savršenu kvalitetu prijevoda",
        "page_context": "Kontekst stranice i web stranice za prijevod",
        "perfect_quality": "Savršena kvaliteta, pristupačna cijena",
        "no_recurring": "Bez ponavljajućih plaćanja, preplaćeni kvota",
        "save_40": "Uštedite 40 % u odnosu na plan od 20 $",
        "save_50": "Uštedite 50 % u odnosu na plan od 20 $"
      },
      "quota": "{estimated_words} riječi ~ {estimated_pages} stranica"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI prijevod",
        "intro": "Linguise s ponosom predstavlja Linguise AI prijevod, novu premium značajku koja koristi AI LLM modele (najnoviji Llama modeli, optimizirani za zadatke prevođenja). Dizajnirana je za web stranice koje zahtijevaju besprijekornu točnost, uzima u obzir i kontekst stranice i cijele web stranice za neusporedive rezultate. Ponudite svojim klijentima vrhunsku kvalitetu prijevoda, osiguravajući da njihova poruka savršeno odjekne na svakom jeziku.",
        "button": "Nadogradite sada"
      },
      "alert": {
        "description": "Ova značajka nije uključena u vaš trenutni plan i zahtijeva zasebnu kupnju.\nAktivirajte ovaj dodatak kako biste otključali sve opcije navedene u nastavku."
      },
      "languages": {
        "title": "Primijeni AI prijevod na jezike",
        "description": "Odaberite određeni jezik na koji želite primijeniti AI prijevod"
      },
      "button": {
        "save": "Spremi postavke"
      },
      "form": {
        "advanced": {
          "title": "Napredne AI upute",
          "description": "Napredne AI upute"
        },
        "enable_mode": {
          "title": "OMOGUĆI AI PRIJEVOD",
          "description": "Odaberite kako želite aktivirati AI prijevod.\nPravila će primijeniti samo sljedeća pravila.\nLive editor će omogućiti aktiviranje prijevoda po stranici iz prikaza live editora.\nPravila i live editor će koristiti obje značajke.",
          "disabled": "Onemogućeno",
          "rules": "Samo pravila",
          "live_editor": "Samo live editor",
          "all": "Pravila i live editor"
        },
        "rule_application": {
          "description": "Primijeni AI prijevod na statički sadržaj, dinamički sadržaj ili oba",
          "title": "Primijeni na sadržaj",
          "all": "Sav sadržaj",
          "static": "Statički sadržaj",
          "dynamic": "Dinamički sadržaj"
        },
        "website_topic": {
          "title": "Tema web stranice",
          "placeholder": "Restoran sushi...",
          "description": "Definirajte temu svoje web stranice za bolju kvalitetu prijevoda (npr. pravna, sushi restoran, online trgovina biciklističkim dijelovima…)\nUnesite temu web stranice na engleskom jeziku."
        },
        "apply_to_urls": {
          "title": "Primijeni na URL-ove",
          "description": "Odaberite određene URL-ove na koje želite primijeniti AI prijevod",
          "all_urls": "Svi URL-ovi",
          "selected_urls": "Odabrani URL-ovi",
          "label": "URL za primjenu",
          "placeholder": "URL za primjenu",
          "wildcard": "Zamjenski znak",
          "regex": "Regularni izraz",
          "add": "Dodaj novi",
          "expression": "Vrsta izraza"
        },
        "apply_languages": {
          "title": "Primijeni na jezike",
          "description": "Odaberite određeni jezik na koji želite primijeniti AI prijevod",
          "all_languages": "Svi jezici",
          "selected_languages": "Odabrani jezici",
          "placeholder": "Odaberite jezike...",
          "feedback": "Morate odabrati jezik"
        },
        "formality": {
          "title": "Formalnost",
          "description": "Odredite stupanj formalnosti u prijevodima, što može biti važno za publiku i kontekst.\n„Neutralno“ će pokušati zadržati originalnu formalnost sadržaja.\n„Formalno“ je za profesionalni, poslovni ili pravni sadržaj (npr. korištenje formalnih zamjenica poput „usted“ u španjolskom).\n„Neformalno“ je za ležerniji, razgovorni sadržaj (npr. korištenje „tú“ u španjolskom).",
          "neutral": "Neutralno",
          "formal": "Formalno",
          "informal": "Neformalno"
        },
        "sentence_structure": {
          "classic": "Klasično",
          "short": "Kratke i udarne rečenice",
          "detailed": "Detaljne i objašnjavajuće rečenice",
          "title": "Struktura rečenice",
          "description": "Definirajte preferenciju stila pisanja."
        },
        "content_purpose": {
          "marketing": "Marketing/promocija (uvjerljiv, angažiran ton)",
          "technical": "Tehnički/instrukcijski (jasno, precizno, usmjereno na akciju)",
          "support": "Podrška korisnicima (empatično, korisno, umirujuće)",
          "legal": "Pravno/usaglašenost (precizno, formalno, nedvosmisleno)",
          "educational": "Obrazovno (jasno, strukturirano, pristupačno)",
          "other": "Ostalo (na engleskom)",
          "title": "Svrha sadržaja",
          "description": "Definirajte funkcionalnu svrhu sadržaja koji se prevodi.",
          "other_placeholder": "Opišite svrhu..."
        },
        "target_audience": {
          "title": "Ciljana publika",
          "description": "Specifikacija namijenjene publike prevedenog sadržaja (na engleskom).",
          "placeholder": "npr. roditelji koji govore španjolski, službenici za zaštitu privatnosti EU-a"
        },
        "override_default_translations": {
          "title": "Zamijeni zadani prijevod",
          "description": "Ako je postavljeno na DA, ova opcija će prisiliti sadržaj da se prevede AI‑jem (Linguise AI) čak i ako je već preveden Cloud AI prijevodom (zadani model)."
        },
        "force_replace_before": {
          "title": "Prisilni ponovni prijevod pomoću AI-ja",
          "description": "Ponovno prevedite pomoću AI-ja sav sadržaj čiji je AI prijevod nastao prije odabranog datuma — primjerice sadržaj preveden starijim modelom. Ponovni prijevod odvija se pri sljedećem posjetu primijenjenim stranicama prema pravilima i troši AI kredite.",
          "before_date": "Prije datuma"
        },
        "model": {
          "current": "Trenutno",
          "title": "Model",
          "description": "Odaberite LLM model prevođenja koji želite koristiti",
          "load_error": "Nije moguće učitati dostupne modele. Molimo pokušajte ponovo kasnije.",
          "thinking_warning": "Ovaj model koristi visoku razinu zaključivanja (\"razmišljanje\") i troši znatno više tokena po prijevodu."
        },
        "override_manual_and_selected": {
          "no_default": "Ne (zadano)",
          "title": "Nadjačaj ručne i odabrane prijevode",
          "description": "Prijevod koji ste ručno uredili prema zadanim se postavkama uvijek prikazuje na vašoj web-stranici, čak i nakon što se generira AI poboljšani prijevod. Postavite na DA da se umjesto toga prikaže AI poboljšani prijevod. Vaši ručni prijevodi se čuvaju i možete se vratiti na njih u bilo kojem trenutku. To se odnosi i na ponovno prevođenje stranica radi dobivanja novih prijevoda; automatski će se koristiti najnoviji prijevod."
        }
      },
      "message": {
        "save_success": "Iz trenutno već prevedenog sadržaja, broj stranica koje bi se poboljšale AI prijevodom je oko {{ai_affected_urls}}.",
        "save_success_only": "Postavke su uspješno spremljene."
      }
    },
    "pricing": {
      "plan": {
        "title": "Naručite kvotu AI prijevoda",
        "buy_button": "KUPI AI PAKET PRIJEVODA"
      },
      "modal": {
        "title": "Potvrdite promjenu plana",
        "description": "Jeste li sigurni da želite promijeniti svoj AI plan prijevoda?",
        "button_cancel": "Odustani",
        "button_confirm": "Potvrdi",
        "loading": "Molimo pričekajte...",
        "amount": "Iznos",
        "credit": "Kredit",
        "total_due": "Ukupno dugovno"
      },
      "comparison": {
        "title": "Google Cloud AI prijevod\nvs Linguise AI prijevod",
        "list": {
          "0": {
            "google": "Brzi i pouzdani prijevodi",
            "linguise": "Rukovanje idiomatskim i tehničkim izrazima"
          },
          "1": {
            "google": "Trenutni prijevodi svih stranica weba",
            "linguise": "Generiranje prijevoda u pozadini"
          },
          "2": {
            "google": "Najbolja kvaliteta, niska cijena",
            "linguise": "Savršena kvaliteta, pristupačna cijena"
          },
          "3": {
            "google": "Najbolje za velike web stranice ili niska proračun",
            "linguise": "Najbolje za web stranicu koja zahtijeva savršenu kvalitetu prijevoda"
          },
          "4": {
            "google": "Kontekst stranice za prijevod",
            "linguise": "Kontekst stranice i weba za prijevod"
          }
        }
      },
      "botom_banner": {
        "title": "Iskusite neusporedivu točnost prijevoda s",
        "sub_title": "Novim Linguise AI prijevodom",
        "description": "Linguise unapređuje svoje usluge automatskog prevođenja uvođenjem Linguise AI prijevoda, moćne nove opcije koja koristi najnovije LLM modele (najnoviji Llama modeli optimizirani za prijevode). Ovaj dodatak pruža programerima weba i agencijama još višu razinu kvalitete prijevoda, idealnu za projekte gdje je savršenstvo ključno. Linguise AI prijevod nadopunjuje naš postojeći visokokvalitetni Google Cloud AI prijevod, nudeći vam veću fleksibilnost i preciznost."
      }
    },
    "success": {
      "tab_title": "Hvala što ste kupili AI prijevodni plan!",
      "title": "Hvala što ste kupili AI prijevodni plan!",
      "subtitle": "Vaš AI prijevodni plan je uspješno kupljen!",
      "message": "Plan AI prijevoda možete upravljati na stranici postavki AI prijevoda.",
      "home": "Upravljaj AI prijevodom"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Ime",
        "description": "Naziv računa"
      },
      "phone": {
        "title": "Telefon",
        "description": "Telefon računa"
      },
      "email": {
        "title": "E‑mail",
        "description": "E‑mail računa"
      },
      "address": {
        "title": "Adresa",
        "description": "Adresa računa",
        "city": "Grad",
        "country": "Država",
        "address1": "Adresa 1",
        "address2": "Adresa 2",
        "postal": "Poštanski broj",
        "state": "Pokrajina"
      },
      "tax": {
        "title": "PDV broj"
      }
    }
  },
  "checkouts": {
    "header": "Plaćanje",
    "payment_method": "Odaberite način plaćanja",
    "stripe_card": "Kreditna kartica (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Unesite novu adresu za naplatu",
      "existing": "Koristi postojeću adresu"
    },
    "pay_stripe": "Potvrdi i plati",
    "terms": "Potvrdom pretplate, dozvoljavate Linguiseu da vam naplaćuje buduća plaćanja u skladu s našim uvjetima. Pretplatu uvijek možete otkazati.",
    "coupon": {
      "title": "Imate li kupon?",
      "placeholder": "Unesite kod kupona ovdje",
      "apply": "Primijeni",
      "percent": "{{0}}% popusta"
    },
    "add_new": "Dodaj novo",
    "use_existing": "Koristi postojeći način plaćanja",
    "recurring": {
      "month_single": "Mjesečna naplata",
      "month_many": "Naplaćuje se svakih {{count}} mjeseci",
      "year_single": "Godišnja naplata",
      "year_many": "Naplaćuje se svakih {{count}} godina",
      "day_single": "Dnevna naplata",
      "day_many": "Naplaćuje se svakih {{count}} dana",
      "week_single": "Tjedna naplata",
      "week_many": "Naplaćuje se svakih {{count}} tjedna"
    },
    "add_new_no_stripe": "Dodaj novu karticu",
    "summary": {
      "title": "Sažetak",
      "subtotal": "Međuzbroj",
      "total": "Ukupno"
    }
  },
  "dashboard": {
    "main": {
      "title": "Nadzorna ploča"
    },
    "statistics": {
      "main_title": "Statistika zadnjih 30 dana",
      "characters": "Prevedeni znakovi",
      "words": "Prevedene riječi",
      "bandwidth": "Unosna propusnost",
      "request": "Zahtjevi",
      "page_views": "Pregledi stranica po jeziku (zadnjih 30 dana)",
      "multilingual_views": "Višejezični pregledi stranica (zadnjih 30 dana)",
      "most_page_viewed": "20 najpregledanijih stranica (zadnjih 30 dana)",
      "no_data_yet": "Još nema podataka",
      "th_language": "Jezik",
      "th_page_views": "Pregledi stranica",
      "real_visitors": "Stvarni posjetitelji",
      "crawler": "Web crawler"
    },
    "planHints": {
      "subscribeButton": "Pretplati se",
      "upgradeButton": "Nadogradi",
      "usedWords": "Trenutno koristite {words_used} riječi",
      "noPlan": "Nema aktivnog plana za ovu domenu. Pretplatite se na plan i počnite prevoditi svoju web stranicu",
      "noPlanShopify": "Nema aktivnog plana za ovu domenu. Pretplatite se na plan u svom Shopify nadzornom panelu i počnite prevoditi svoju web stranicu",
      "trialUsage": "Trenutno koristite {words_used} riječi od {words_allowed} riječi uključenih u probni plan.",
      "trialEnds": "Probni mjesec je aktivan do {trial_ends}.",
      "subscribeMessage": "Pretplatite se prije završetka kako bi vaša web stranica ostala prevedena",
      "subscribeMessageShopify": "Pretplatite se iz svog Shopify nadzornog panela prije završetka kako bi vaša web stranica ostala prevedena",
      "trialReachedLimit": "Dostigli ste maksimalni broj prevedenih riječi za probni period.\nPretplatite se na jedan od naših planova kako biste nastavili prevoditi web stranicu.",
      "paidUsage": "Iskoristili ste {words_used} / {words_allowed} prevedenih riječi u vašem planu.",
      "paidReachedLimit": "Dostigli ste maksimalni broj prevedenih riječi za trenutni plan.\nNadogradite svoj plan kako biste nastavili prevoditi sadržaj web stranice.",
      "trialOfferedUsage": "Trenutno koristite {words_used} riječi od {words_allowed} riječi uključenih u probni plan (uključujući {free_words} besplatnih riječi)",
      "paidOfferedUsage": "Iskoristili ste {words_used} / {words_allowed} prevedenih riječi u vašem planu (uključujući {free_words} besplatnih riječi)",
      "noPlanExtra": "Napomena: neaktivne domene i njihovi podaci redovito se automatski brišu.",
      "planRecommended": "Na temelju trenutnog volumena prijevoda preporučujemo sljedeći plan:",
      "planMaximumWords": "{{words}} riječi",
      "notHaveTranslatedWords": "Još niste napravili nijedan prijevod"
    },
    "translationSetup": {
      "kicker": "POSTAVLJANJE PODDOMENE",
      "title": "Provjeri postavke prijevoda",
      "description": "Pregledaj DNS, prevedene hostove, pristup izvornom web-mjestu i ograničenja računa.",
      "starting": "Provjera...",
      "button": "Provjeri postavke",
      "viewLatest": "Prikaži posljednji rezultat",
      "viewCurrent": "Prikaži trenutačnu provjeru",
      "runAgain": "Ponovno pokreni provjeru",
      "viewDetails": "Prikaži pojedinosti",
      "hideDetails": "Sakrij pojedinosti",
      "error": "Nije moguće provjeriti postavke",
      "allPassed": "Sve su provjere prošle",
      "setupNeedsAttention": "Postavke zahtijevaju pozornost",
      "setupNeedsAttentionDescription": "Jedna ili više provjera nije uspjela. Pregledaj stavke u nastavku ili kontaktiraj podršku Linguise.",
      "lastChecked": "Posljednja provjera {{time}}",
      "domainOwnership": "Vlasništvo domene",
      "domainOwnershipDescription": "Pronađen je zapis za potvrdu",
      "domainOwnershipFailure": "Nije moguće potvrditi DNS zapis vlasništva.",
      "translatedHosts": "Prevedeni hostovi",
      "translatedHostsDescription": "Provjereno jezičnih hostova: {{count}}",
      "translatedHostsFailure": "Jedan ili više CNAME zapisa za jezike nisu ispravni.",
      "subdomainPage": "Stranica poddomene",
      "subdomainPageDescription": "{{count}} prevedenih stranica prihvaća HTTPS",
      "subdomainPageFailure": "TLS veza nije uspjela pri otvaranju jedne ili više prevedenih stranica.",
      "originalSite": "Izvorno web-mjesto",
      "originalSiteDescription": "Provjere DNS-a, TLS-a i odgovora izvornog web-mjesta",
      "originalSiteFailure": "Provjera DNS-a, TLS-a ili odgovora izvornog web-mjesta nije uspjela.",
      "documentationAdvice": {
        "dns": "Pregledaj postavke DNS-a",
        "tls": "Pregledaj postavke HTTPS-a",
        "origin": "Pregledaj postavke izvornog web-mjesta",
        "diagnostic": "Pregledaj korake za rješavanje problema"
      },
      "evidence": {
        "originDns": "Izvorni DNS",
        "originTls": "Izvorni TLS",
        "originHttp": "Izvorni odgovor",
        "observedTargets": "Uočeni ciljevi",
        "recordCount": "Pronađeni zapisi",
        "addressCount": "Pronađene adrese",
        "statusCode": "HTTP status",
        "redirect": "Preusmjeravanje",
        "expiresAt": "Certifikat istječe",
        "raw": "{{key}}",
        "noValue": "Nema vrijednosti"
      },
      "checkerError": "Neke provjere nije bilo moguće dovršiti.",
      "coreLocation": "Provjereno s lokacije {{location}}",
      "status": {
        "queued": "U redu čekanja",
        "running": "U tijeku",
        "completed": "Dovršeno",
        "failed": "Neuspjelo",
        "passed": "Prošlo",
        "warning": "Upozorenje",
        "unknown": "Nepoznato",
        "skipped": "Preskočeno",
        "not_applicable": "Nije primjenjivo"
      }
    },
    "throttling": {
      "title": "Ograničenje prijevoda",
      "description": "Privremena ograničenja korištenja",
      "unavailable": "Privremena ograničenja prijevoda nisu dostupna",
      "window": "{{used}} / {{max}} riječi",
      "resetsIn": "Ponovno se postavlja za {{time}}",
      "throttled": "Prijevod je privremeno pauziran",
      "throttledDescription": "Dosegnuto je privremeno ograničenje korištenja. Prijevod se nastavlja nakon ponovnog postavljanja tog razdoblja."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "KORAK {{step}} OD {{total}}",
      "doneLabel": "ZAVRŠENO, MOŽETE POČETI PREVOĐENJE!",
      "finish": {
        "title": "",
        "description": "Ovo je API ključ za upotrebu na vašoj web stranici"
      },
      "instructions": "Upute za instalaciju",
      "domainSetting": "Postavke domene",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP skripta",
        "wizardWordpressStep1": "1. Instalirajte ",
        "wizardWordpressStep2": "\n 2. U postavkama dodatka kopirajte i zalijepite svoj API ključ\n",
        "wizardWordpressStep3": "3. Spremni ste za prevođenje\n\n",
        "wizardWordpressStep4": "Za detaljnije upute, pogledajte našu dokumentaciju: ",
        "wizardJoomlaStep1": "1. Joomla paket link: ",
        "wizardJoomlaStep2": "\n2. U postavkama konfiguracije ekstenzije kopirajte i unesite svoj API ključ",
        "wizardJoomlaStep3": "3. U konfiguraciji modula postavite jezike koje želite prikazati i umetnite svoj modul tamo gdje ga trebate.",
        "wizardJoomlaStep4": "\n 4. Spremni ste za prevođenje\n\n",
        "wizardPhpStep1": "1. Preuzmite naš php skript i ovdje ",
        "wizardPhpStep2": "\n2. Slijedite upute za instalaciju na našoj stranici dokumentacije ovdje ",
        "wizardPhpStep3": "\n3. Dodajte modul na svoje stranice.",
        "wizardPhpStep4": "\n Kopirajte sljedeći kôd i dodajte ga u head vaše HTML stranice – automatski će prikazati modul prekidača\n",
        "dispatchStep1": "Uspješno smo poslali potrebne podatke Linguise dodatku, sada možete zatvoriti ovaj prozor.",
        "dispatchStep2": "U slučaju da token nedostaje kada zatvorite ovaj prozor, kopirajte sljedeći token:",
        "dispatchStep3": "Također možete kopirati ovaj isječak kako biste automatski omogućili naš preklopnik zastavica",
        "wizardOtherStep1": "Slijedite upute u nastavku za instalaciju Linguise na svoju domenu.\n",
        "wizardOtherStep2": "Kopirajte sljedeći kôd i dodajte ga u head vaše HTML stranice – automatski će prikazati modul prekidača.\n"
      },
      "trialAlreadyUsed": "Čini se da ste već iskoristili besplatno probno razdoblje, pa trebate dobiti kvotu za prijevod\nMolimo pretplatite se na plan ili nas kontaktirajte ako trebate produljiti probu.",
      "usefulLinks": "Korisni linkovi za početak",
      "linkDocumentation": "Dokumentacija",
      "linkExtensionDl": "Preuzimanje ekstenzije",
      "linkSubscribe": "Pretplatite se na plan sada",
      "linkDashboard": "Idi na nadzornu ploču",
      "exclusion": {
        "title": "Nazivi tvrtki i proizvoda",
        "description": ""
      },
      "finishButton": "Završite postavljanje",
      "subdomains": "Poddomene",
      "subdomain_setup": "Postavljanje domene",
      "subdomain_auto_setup": "Automatski poveži svoj DNS",
      "subdomain_manual_setup": "Samostalno dodaj DNS zapise",
      "subdomain_skip": "Učini kasnije",
      "auto_subdomains_info": "Vaš CMS za izradu stranica zahtijeva DNS konfiguraciju za postavljanje jezika po poddomeni (npr. hr.domain.com).",
      "auto_subdomains_info_2": "To možete učiniti automatski uz Entri. Samo kliknite gumb \"Connect your DNS automatically\" da započnete povezivanje s vašim DNS upraviteljem i dodajte ih putem Entri.",
      "auto_subdomains_info_manual": "Ili, možete ručno konfigurirati svoju domenu klikom na gumb \"Add DNS entries myself\".",
      "breadcrumbs": {
        "step1": "Korak 1: Domena, CMS i jezici",
        "step2": "Korak 2: DNS jezika",
        "step3": "Korak {{step}}: Upute za instalaciju"
      }
    },
    "form": {
      "urls": {
        "dash": "Crtica -",
        "underscore": "Podvlaka _",
        "title": "Prevedi URL-ove",
        "description": "Želite li prevesti sve stranice",
        "char_description": "Znak koji će se koristiti za zamjenu neovlaštenih znakova u URL-ovima",
        "advertisement_title": "⚠ Postavili ste mnogo jezika.\n",
        "advertisement": "Obično savjetujemo da započnete s prevođenjem web stranica s nekoliko jezika. Tako ćete dobiti uvid u količinu riječi na vašoj stranici. Također je bolje za SEO, jer će Google botovi brže indeksirati sve vaše stranice ako ih je početno manje. Nakon tjedna možete dodati još nekoliko jezika i tako dalje."
      },
      "url": {
        "title": "URL",
        "description": "Unesite URL vaše glavne domene koji počinje s http:// ili https://",
        "placeholder": "URL domene",
        "advertisement_http": {
          "title": "Ne koristite https protokol",
          "description": "Provjerite da vaša domena zaista ne koristi https protokol, koji je danas preporučen."
        },
        "advertisement_www": {
          "title": "Vaša poddomena nije www",
          "description": "U većini slučajeva zadana poddomena je www (npr. https://www.mydomain.com). To možda nije vaš slučaj, ali provjerite je li domena koju želite dodati ispravna."
        },
        "invalid_url": {
          "line1": "Nismo uspjeli pronaći vašu domenu. Provjerite je li vaša domena javno dostupna putem interneta i nije li preusmjerena na drugu lokaciju.",
          "line2": "Ako ste sigurni da je domena dostupna, možete preskočiti provjeru domene i ponovno pritisnuti gumb \"Next step\"",
          "contact": "U svakom slučaju možete nas kontaktirati na",
          "force": "Preskoči provjeru domene"
        },
        "invalid_subdomain_url": "Ovaj URL nije dopušten. Poddomene moraju biti u obliku: https://www.domain.tld ili https://domain.tld bez poddirektorija."
      },
      "account": {
        "title": "Račun",
        "description": "Odaberite račun za dodjelu ove domene",
        "placeholder": "Odaberite račun...",
        "feedback": "Morate odabrati račun"
      },
      "platform": {
        "title": "Platforma",
        "description": "Molimo odaberite platformu vaše web stranice po nazivu CMS-a.",
        "learn": "Saznajte kako odabrati",
        "placeholder": "Pretražite platformu po nazivu CMS-a...",
        "info": {
          "title": "⚠ Ova platforma je nedavno dodana.\n",
          "desc": "Ova platforma za izradu web stranica podržana je od strane Linguise, iako je nedavno dodana. Ako imate bilo kakvih problema, kontaktirajte nas putem izravnog e‑maila za podršku:"
        },
        "description_read_only": "Platforma koju vaša web stranica koristi",
        "feedback": "Morate odabrati platformu"
      },
      "language": {
        "title": "Jezik",
        "description": "Odaberite osnovni jezik vaše web stranice",
        "placeholder": "Odaberite jezik...",
        "feedback": "Morate odabrati jezik",
        "description_read_only": "Osnovni jezik vaše web stranice"
      },
      "token": {
        "title": "API ključ",
        "description": "Ovo je API ključ koji ćete kopirati na svoju web stranicu",
        "copy": "Kopiraj u međuspremnik",
        "reset": "Resetiraj API ključ",
        "reset_confirm": "Molimo potvrdite resetiranje API ključa"
      },
      "languages": {
        "title": "Jezici za prevođenje",
        "description": "Odaberite jezike na koje želite da vaša web stranica bude prevedena",
        "placeholder": "Odaberite jezike...",
        "feedback": "Morate odabrati jezik"
      },
      "defaultRules": {
        "title": "Zadana pravila",
        "description": "Definirali smo skup pravila koja se moraju koristiti kako bi se poboljšao prijevod i izbjeglo neželjeno prevođenje sadržaja, poput WordPress nadzorne ploče.\nTa pravila možete ukloniti ili urediti kasnije ako želite."
      },
      "disallow_deletion": "Ne možete izbrisati domenu s aktivnom pretplatom",
      "delete_confirm": "Molimo potvrdite brisanje domene",
      "delete": "Izbriši domenu",
      "dynamic": {
        "title": "Prevedi dinamički sadržaj",
        "description": "Dinamički sadržaj generiran JavaScriptom i AJAX zahtjevima bit će preveden (Ova opcija će povećati korištenje vaših prijevoda)"
      },
      "partial_translations": {
        "title": "Dozvoli djelomičan prijevod",
        "description": "Ako je vaš račun dosegao kvotu za prijevod, ali stranica i dalje zahtijeva prijevod, Linguise može nastaviti prikazivati stranicu s već prevedenim sadržajem.\nMeđutim, neki dijelovi stranice ostat će neprevedeni dok ne povećate kvotu.\n\nIako mali iznos neprevedenog sadržaja obično ne šteti SEO-u, previše neprevedenog sadržaja može negativno utjecati na iskustvo korisnika.\nDa biste to ublažili, možete postaviti prag za postotak neprevedenog sadržaja dozvoljenog na stranici. Ako neprevedeni sadržaj premaši ovaj prag, korisnici će se automatski preusmjeriti na izvornu jezičnu verziju stranice.",
        "never": "Nikada"
      },
      "translate_error_pages": {
        "title": "Prevedi stranice s greškama",
        "description": "Linguise može prevesti sve stranice s greškama, no ako vaša stranica s greškom sadrži dinamički sadržaj, poput IP adrese ili ID‑ja zahtjeva, trebali biste izbjegavati prevođenje tih stranica.",
        "not_found_page": {
          "title": "Prevedi 404 stranicu"
        },
        "error_page": {
          "title": "Prevedi ostale stranice s greškama"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Pronađena postojeća domena",
          "description": "Postoji domena za ovog korisnika, želite li je koristiti?"
        }
      },
      "search_tl": {
        "title": "Pretraži prijevode",
        "description": "Omogući pretraživanje prijevoda za vašu platformu web stranice (Eksperimentalno, ova opcija će povećati korištenje prijevoda)"
      },
      "shopify_promo": {
        "info": "Dobre vijesti! Sada imamo Shopify nativnu aplikaciju koju možete instalirati iz Shopify App Storea",
        "hyperlink": "Kliknite ovdje i instalirajte Linguise iz aplikacije.",
        "next_btn": "Idite u Shopify trgovinu da biste instalirali aplikaciju",
        "info_legacy": "Dobre vijesti! Sada imamo Shopify nativnu aplikaciju koju možete instalirati iz Shopify App Storea",
        "description_legacy": "Odaberite platformu \"Shopify\" umjesto \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Dobre vijesti! Sada imamo Wix nativnu aplikaciju koju možete instalirati iz Wix App Marketa.",
        "hyperlink": "Kliknite ovdje i instalirajte Linguise iz aplikacije.",
        "next_btn": "Idite u Wix App Market da biste instalirali aplikaciju",
        "info_legacy": "Dobre vijesti! Sada imamo Wix nativnu aplikaciju koju možete instalirati iz Wix App Marketa.",
        "description_legacy": "Odaberite platformu \"Wix\" umjesto \"Wix Legacy\""
      },
      "ai_disallow_deletion": "Ne možete izbrisati ovu domenu dok je AI kvota još dostupna.\n\nKontaktirajte naš tim za podršku ako želite izbrisati ovu domenu na",
      "language_removal": {
        "card": {
          "title": "Izbrišite prijevode uklonjenih jezika",
          "description": "Ovi su jezici uklonjeni s vaše web-stranice, ali njihovi se spremljeni prijevodi i dalje računaju u vašu kvotu. Izbrišite ih i vratite te riječi.",
          "button": "Izbriši prijevode"
        },
        "hint": "Upotrijebljene riječi vratit će se u vašu kvotu. To možete učiniti jednom svakih {{days}} dana za svaku web-stranicu.",
        "modal": {
          "title": "Izbrisati prijevode?",
          "intro": "Ovi će prijevodi biti trajno izbrisani:",
          "warning": "Ovu radnju nije moguće poništiti. Upotrijebljene riječi vratit će se u vašu kvotu, što može potrajati nekoliko minuta.",
          "limit": "To možete učiniti jednom svakih {{days}} dana za svaku web-stranicu.",
          "confirm": "Izbriši prijevode"
        },
        "scheduled": "Prijevodi se brišu, a vaša će se kvota uskoro ažurirati.",
        "cooldown": "Prijevodi za ovu web-stranicu nedavno su izbrisani. Ponovno ih možete izbrisati {{date}}.",
        "latest_completed": {
          "title": "Posljednje dovršeno brisanje",
          "description": "Pregledajte izbrisane jezike i riječi vraćene u vašu kvotu.",
          "languages": "Izbrisani jezici",
          "words_returned": "Riječi vraćene u vašu kvotu: {{words}}",
          "completed_at": "Dovršeno {{date}}"
        },
        "status": {
          "recent_title": "Nedavno brisanje prijevoda",
          "recent_description": "Pratite posljednje brisanje i saznajte kada će sljedeće biti dostupno.",
          "progress_title": "Napredak brisanja",
          "loading": "Provjera napretka brisanja...",
          "unavailable": "Nije moguće učitati napredak brisanja. Osvježite stranicu i pokušajte ponovno.",
          "label": "Status",
          "pending": "Na čekanju",
          "processing": "U tijeku",
          "completed": "Dovršeno",
          "failed": "Neuspjelo",
          "unknown": "Status nije dostupan",
          "percent": "{{percent}} % dovršeno",
          "current_stage": "Trenutačni korak: {{stage}}",
          "processed": "Obrađeno zapisa: {{processed}}",
          "processed_total": "Obrađeno {{processed}} od {{total}} zapisa",
          "requested_at": "Zatraženo {{date}}",
          "started_at": "Započeto {{date}}",
          "completed_at": "Dovršeno {{date}}",
          "cooldown_period": "To možete učiniti jednom svakih {{days}} dana za svaku web-stranicu.",
          "cooldown_blocked": "Još nije moguće pokrenuti novo brisanje.",
          "stage": {
            "queued": "Čeka se početak",
            "processing": "U tijeku",
            "refund_summary": "Izračun vraćenih riječi",
            "search_translations": "Brisanje prijevoda pretraživanja",
            "url_translations": "Brisanje prijevoda URL-ova",
            "translations": "Brisanje prijevoda",
            "completed": "Dovršeno",
            "failed": "Neuspjelo",
            "unknown": "U tijeku"
          }
        },
        "forbidden": "Nemate dopuštenje za brisanje prijevoda."
      }
    },
    "main": {
      "edit": "Uredi domenu",
      "add": "Dodaj domenu",
      "wizard": "Dobrodošli! Čarobnjak za stvaranje nove domene",
      "common": "Domena"
    },
    "notice": {
      "broken_card": "Nismo uspjeli obnoviti vaš plan za {{url}} trenutnom metodom plaćanja, ažurirajte svoju karticu za plaćanje",
      "quota_reached": "Vaša kvota za prijevod za {{url}} je dosegnuta, nadogradite plan kako biste nastaviti prevođenje web stranice",
      "ai_no_subscription": "AI prijevod za {{url}} zahtijeva aktivnu pretplatu ili aktivnu probu. Prestan će raditi bez nje, nadogradite kako biste nastavili",
      "important": "Važno",
      "quota_reached_button": "Nadogradite svoj plan odmah",
      "broken_card_button": "Ažurirajte svoju karticu za plaćanje",
      "ai_no_subscription_button": "Nadogradite svoj plan odmah",
      "quota_warning": "Vaša kvota prijevoda za {{url}} dosegla je {{throttling_used_percent}}%, to će se resetirati za {{ttl}}",
      "locked": "Domena {{url}} trenutno je zaključana za migraciju, i dalje možete pristupiti svojoj web stranici, ali ne možete uređivati ​​ili dodavati nove prijevode!"
    },
    "subdomains": {
      "config_ok": "DNS poddomena je pravilno konfiguriran.",
      "config_invalid": "DNS poddomena zahtijeva dodatnu konfiguraciju da bi radila.",
      "config_check": "Provjerava se konfiguracija DNS poddomena, molimo pričekajte...",
      "entri_timeout": "Entri je izvijestio da je vaš proces propagacije DNS poddomena istekao, trebate pokušati ponovno ili to učiniti ručno.",
      "entri_process": "Vaš DNS je dodan putem Entri i obično traje 10‑30 minuta da se propagira (primijenite sve poddomene za svoje jezike, npr. hr.domain.com). Ako validacija DNS-a nije završena nakon 24 sata, možete kontaktirati naš tim za podršku: support@linguise.com",
      "entri_ok": "Propagacija DNS-a je u tijeku! Čekanje propagacije...",
      "infos": "Morate dodati ove DNS unose u svoje DNS zapise domene kako biste aktivirali prijevod. Kliknite gumb za provjeru kada je to gotovo. Moguće je da će propagacija DNS zapisa potrajati neko vrijeme, pa ćete se možda morati vratiti nakon nekoliko minuta ili sati.",
      "check": "Provjerite konfiguraciju DNS-a"
    },
    "subscription": {
      "next_payment_amount": "Nadolazeći troškovi",
      "next_payment_date": "Datum sljedeće uplate",
      "invoice": {
        "header": "Povijest računa",
        "date": "Datum",
        "amount_due": "Iznos",
        "status": "Status",
        "actions": "Radnje",
        "description": "Kad transakcije budu dostupne, možete ih pregledati ovdje.",
        "status_text": {
          "draft": "Nacrt",
          "failed": "Neuspjelo",
          "open": "Na čekanju",
          "paid": "Plaćeno",
          "retrying": "Ponovno pokušavanje",
          "uncollectible": "Neprikupljivo",
          "void": "Poništeno"
        },
        "view": "Pregled",
        "empty": "Nema nedavnih računa za ovu pretplatu",
        "retry_payment": "Ponovi"
      },
      "next_cancellation": "Datum otkazivanja",
      "cancel": "Otkaži pretplatu",
      "change_plan": "Promijeni plan",
      "change": "Promijeni",
      "suspend": "Obustavi plaćanje",
      "resume": "Nastavi pretplatu",
      "back": "Natrag",
      "save": "Spremi",
      "confirm_resume": "Jeste li sigurni da želite nastaviti ovu pretplatu?",
      "confirm_cancel": "Jeste li sigurni da želite otkazati ovu pretplatu?",
      "confirm_header": "Jeste li sigurni?",
      "missing_status": "Ova pretplata nedostaje",
      "not_found": "Nije pronađena pretplata za ovu domenu",
      "confirm_manual_retry": "Jeste li sigurni da želite ponovno pokušati ovu uplatu?",
      "no_payment_method": "Nepoznato",
      "remove_billing": "Ukloni",
      "shopify_maneged": "Ova pretplata upravlja se putem Shopifyja. Molimo upravljajte njome iz vašeg Shopify admin panela.",
      "unknown_plan": "Nepoznat plan"
    }
  },
  "domain_listing": {
    "add": "Dodaj web stranicu",
    "select": "Odaberi domenu"
  },
  "editable": {
    "number": "broj {{id}}"
  },
  "footer": {
    "about": "O nama",
    "support": "Podrška"
  },
  "frontendEditor": {
    "main": "Live uređivač",
    "description": "Live uređivač vam pomaže izravno uređivati prijevode na vašoj web stranici.",
    "button": "Otvori Live uređivač",
    "language_selection": "Odabir jezika za prijevod",
    "video_label": "Naučite kako koristiti Live uređivač"
  },
  "general": {
    "403": {
      "tab_title": "Ooops - 403 Greška",
      "title": "Pristup odbijen",
      "message": "Izgleda da nemate pristup traženoj stranici.",
      "home": "Vrati se na početnu"
    },
    "404": {
      "tab_title": "Ooops - 404 Greška",
      "title": "Stranica nije pronađena",
      "message": "Čini se da ste skrenuli s puta. Ne brinite... svima se to događa. Evo male savjete koji vam mogu pomoći da se vratite na pravi put.",
      "home": "Vrati se na početnu"
    },
    "500": {
      "tab_title": "500 Greška",
      "title": "Interna greška servera",
      "message": "Zašto ne pokušate osvježiti stranicu? ili nas možete kontaktirati",
      "home": "Vrati se na početnu"
    },
    "fields": {
      "alert": "Neka polja nisu valjana, molimo ispravite nevažeća polja.",
      "invalid": "Ovo polje nije valjano",
      "phone_re": "Broj telefona nije valjan",
      "phone_invalid": "Broj telefona nije valjan",
      "email": "Polje za e-poštu nije važeće"
    },
    "table": {
      "no_data": "Još nema podataka..."
    },
    "saving": "Spremanje ...",
    "save": "Spremi",
    "save_and_quit": "Spremi i izađi",
    "invite": "Pozovi",
    "cancel": "Otkaži",
    "yes": "Da",
    "no": "Ne",
    "nextStep": "Sljedeći korak",
    "loading": "Molimo pričekajte dok se aplikacija učitava",
    "goback": "Idi natrag",
    "manage": "Upravljaj",
    "delete": "Izbriši",
    "deleting": "Brisanje ...",
    "confirm": "Potvrdi",
    "unknown": "Nepoznato",
    "hide": "Sakriti",
    "show": "Pokazati",
    "on": "Na",
    "off": "Isključeno",
    "default": "Zadano"
  },
  "home": {
    "header": "Početna",
    "manage": "Upravljaj pretplatom",
    "canceled": "Zakazano za otkazivanje",
    "activate_now": "Aktiviraj sada",
    "activate_plan_now": "Pretplati se sada",
    "upgrade_plan_now": "Nadogradi plan sada",
    "trial_message_part_1": "Trenutno ste na probnom planu, ",
    "trial_message_part_2": "možete aktivirati članstvo u bilo kojem trenutku.",
    "add": "Dodaj domenu",
    "table": {
      "title": "Domene",
      "description": "Popis vaših domena, kliknite na domenu za upravljanje prijevodima"
    },
    "domains": {
      "empty": "Nemate domena na ovom računu"
    },
    "accountsList": {
      "title": "Računi",
      "add": "Dodaj novi račun",
      "name": "Naziv računa"
    },
    "update_credit_card": "Ažurirajte podatke o kreditnoj kartici",
    "cancelling_subs": "Otkaže se {{0}}",
    "resume_subscription": "Nastavi pretplatu",
    "shopify_managed": "Upravlja Shopify",
    "trial_ends_at": "Završava u {{0}}",
    "free_trial": "Besplatna proba",
    "no_subs": "Nema aktivne pretplate"
  },
  "invoices": {
    "title": "Računi",
    "list": {
      "title": "Popis računa"
    },
    "table": {
      "customer": "Kupac",
      "domain": "Domena",
      "amountPaid": "Plaćeni iznos",
      "status": "Status",
      "date": "Datum",
      "invoice": "Račun",
      "pay": "Plati račun",
      "actions": "Radnje",
      "deleted_domain": "Domena izbrisana",
      "plan_name": "Plan",
      "action": "Radnja"
    },
    "listPending": {
      "title": "Popis čekajućih računa"
    }
  },
  "language_settings": {
    "display": "Prikaz popisa jezika",
    "position": "Pozicija",
    "display_help_text": "Prikaz zastave i/ili naziva jezika. Zadana pozicija preklopnika jezika može biti bilo gdje u sadržaju ili na fiksnoj poziciji koja ostaje fiksna ili se pomiče pri skrolanju",
    "side_by_side": "Jedan pored drugog",
    "dropdown": "Padajući izbornik",
    "popup": "Iskačući prozor",
    "flag": "Zastava",
    "lang_name": "Naziv jezika",
    "lang_short_name": "Kratki nazivi",
    "positions": {
      "in_place": "Na mjestu",
      "top_left": "Gore lijevo",
      "top_left_no_scroll": "Gore lijevo (bez skrolanja)",
      "top_right": "Gore desno",
      "top_right_no_scroll": "Gore desno (bez skrolanja)",
      "bottom_left": "Dolje lijevo",
      "bottom_left_no_scroll": "Dolje lijevo (bez skrolanja)",
      "bottom_right": "Dolje desno",
      "bottom_right_no_scroll": "Dolje desno (bez skrolanja)"
    },
    "lang_names_display": {
      "title": "Prikaz naziva jezika",
      "help_text": "U preklopniku jezika, prikazati nazive jezika na engleskom ili na izvornom jeziku, npr. French ili Français",
      "english": "Engleski",
      "native_languages": "Izvorni jezici"
    },
    "flag_shape": {
      "title": "Stil zastave",
      "help_text": "Koristite okrugle ili pravokutne SVG ikone zastava",
      "round": "Okrugla",
      "rectangular": "Pravokutna"
    },
    "english_flag_type": {
      "title": "Vrsta engleske zastave",
      "help_text": "Koristite zastavu Velike Britanije ili SAD-a za engleski",
      "usa": "Zastava SAD-a",
      "great_britain": "Zastava Velike Britanije"
    },
    "german_flag_type": {
      "title": "Vrsta njemačke zastave",
      "help_text": "Koristite zastavu Austrije ili Njemačke za njemački",
      "german": "Zastava Njemačke",
      "austria": "Zastava Austrije"
    },
    "spain_flag_type": {
      "title": "Vrsta španjolske zastave",
      "help_text": "Koristite zastavu Meksika ili Španjolske za španjolski",
      "spanish": "Zastava Španjolske",
      "mexico": "Zastava Meksika",
      "peruvian": "Zastava Perua"
    },
    "portugal_flag_type": {
      "title": "Vrsta portugalske zastave",
      "help_text": "Koristite portugalsku ili brazilska zastavu za portugalski",
      "portugal": "Zastava Portugala",
      "brazil": "Zastava Brazila"
    },
    "taiwanese_flag_type": {
      "title": "Vrsta tajvanske zastave",
      "help_text": "Koristite tajvansku ili kinesku zastavu za tajvanski",
      "taiwanese": "Zastava Tajvana",
      "chinese": "Kineska zastava"
    },
    "flag_border_radius": {
      "title": "Radijus rubova zastave (px)",
      "help_text": "Ako koristite pravokutni oblik zastave možete primijeniti prilagođeni radijus rubova u pikselima"
    },
    "flag_width": {
      "title": "Veličina zastave (px)",
      "help_text": "Odaberite veličinu zastava u pikselima. To ne mijenja težinu slike jer je u .svg formatu"
    },
    "lang_color": {
      "color_title": "Boja naziva jezika",
      "color_help_text": "Odaberite zadanu boju teksta za nazive jezika",
      "hover_color_title": "Boja naziva jezika pri lebdenju",
      "hover_color_help_text": "Odaberite boju teksta pri lebdenju mišem za nazive jezika",
      "color_popup_title": "Boja jezika u iskačućem prozoru",
      "color_popup_help_text": "Boja naslova jezika u iskačućem prozoru ili padajućem izborniku",
      "hover_color_popup_title": "Boja jezika pri lebdenju u iskačućem prozoru",
      "hover_color_popup_help_text": "Odaberite boju teksta naslova jezika pri lebdenju mišem u iskačućem prozoru ili padajućem izborniku"
    },
    "flag_box_shadow": {
      "shadow_title": "Sjena okvira zastave",
      "shadow_help_text": "Boja i veličina sjene za vaše zastave jezika",
      "hover_shadow_title": "Sjena okvira zastave pri lebdenju",
      "hover_shadow_help_text": "Boja i veličina sjene za vaše zastave jezika pri lebdenju mišem",
      "shadow_h_offset": "Horizontalni pomak sjene (px)",
      "shadow_v_offset": "Vertikalni pomak sjene (px)",
      "shadow_blur": "Zamagljenost sjene (px)",
      "shadow_spread": "Proširenje sjene (px)",
      "shadow_color": "Boja sjene"
    },
    "order": "Redoslijed jezika",
    "language_order_help": "Redoslijed jezika koji će biti prikazan u preklopniku jezika. Možete povući i ispustiti jezik kako biste ga preuredili.",
    "order_reset": "Resetiraj redoslijed",
    "language_order_dragdrop": "Možete povući i ispustiti jezik kako biste ga preuredili.",
    "popup_lang_name": "Naziv jezika u iskačućem prozoru",
    "preview": "Pregled jezika"
  },
  "link": {
    "form": {
      "original": {
        "title": "Izvorni izvor",
        "description": "Dodajte izvorni URL poveznice i zamijenite ga ispod prema jeziku za prijevod",
        "srcset_description": "Uređujete URL slike. Molimo provjerite dokumentaciju, posebno ako koristite srcset ili ne znate što je to",
        "link": "Poveznica",
        "match_link": "Način podudaranja",
        "match_exact": "Točno",
        "match_wildcard": "Džoker",
        "match_regex": "Regularni izraz"
      },
      "alternative_languages": {
        "title": "Linkovi za zamjenu",
        "description": "Zamijenite medijske linkove i vanjske linkove na vašim stranicama, prema jeziku…",
        "link": "Link za zamjenu"
      },
      "error": {
        "atLeastOne": "Molimo dodajte barem jedan prijevod.",
        "url": "URL je neispravan",
        "extension": "Link treba imati ekstenziju, ali ne smije biti .html ili .php. Također link ne smije sadržavati jezični put, npr. \"/fr\"",
        "regex": "Regex je neispravan",
        "wildcard": "Wildcard link ima neispravan protokol"
      }
    },
    "main": {
      "parent": "Linkovi",
      "edit": "Uredi link"
    }
  },
  "links": {
    "title": "Upravljanje medijskim i vanjskim linkovima",
    "description": "Popis i uređivanje medijskih ili vanjskih linkova na vašoj web stranici.",
    "add": "Dodaj link",
    "delete": "Obriši link",
    "table": {
      "original": "Original",
      "language": "Jezik",
      "translation": "Prijevod",
      "action": "Radnja",
      "delete_confirm": "Molimo potvrdite brisanje linka"
    }
  },
  "members": {
    "header": "Članovi",
    "invite": "Pozovi novog člana",
    "modal": {
      "inviteHeader": "Pozovi novog člana",
      "editHeader": "Uredi člana",
      "detachHeader": "Odveži člana",
      "detachBody": "Jeste li sigurni da želite odvezati člana od ovog računa?",
      "selfDetachBody": "Jeste li sigurni da se želite odvezati od upravljanja ovim računom? Nakon toga, nećete moći pristupiti podacima vezanim uz ovaj račun."
    },
    "table": {
      "title": "Popis članova",
      "description": "Uloge članova i pristup domenama",
      "name": "Ime",
      "email": "E‑mail",
      "websites": "Web stranice",
      "languages": "Jezici",
      "role": "Uloga",
      "status": "Status",
      "resendInvite": "ponovno pošalji",
      "inviteSent": "poziv je poslan",
      "actions": "Radnje",
      "edit": "Uredi",
      "detach": "Odveži",
      "empty": "Još nemate članova",
      "all_website": "Sve web stranice i jezici",
      "roles": {
        "admin": "Administrator",
        "manager": "Menadžer",
        "translator": "Prevoditelj"
      },
      "statuses": {
        "pending": "Na čekanju",
        "accepted": "Prihvaćeno",
        "declined": "Odbijeno"
      }
    },
    "errors": {
      "role": "Morate odabrati ulogu",
      "domains": "Morate odabrati najmanje 1 web stranicu za odabranu ulogu",
      "languages": "Morate odabrati najmanje 1 jezik za odabrane web stranice"
    },
    "inviteSent": "Vaš poziv je uspješno poslan"
  },
  "pagination": {
    "showing": "Prikazano {{limit}} od {{total}} rezultata",
    "showing_only_count": "Prikazano {{limit}} rezultata"
  },
  "payments_method": {
    "header": "Načini plaćanja",
    "table": {
      "title": "Popis načina plaćanja",
      "description": "Priključeni načini plaćanja vašem računu",
      "default": "Zadano",
      "action_edit_remove": "Uredi ili ukloni",
      "action_remove": "Ukloni",
      "action_default": "Postavi kao zadano",
      "action_fallback": "Postavi kao rezervno",
      "expires": "Istječe",
      "add_new_card": "Dodaj način plaćanja",
      "action_fallback_remove": "Ukloni iz rezervnog",
      "fallback": "Rezervno",
      "action_edit": "Uredi",
      "action_delete": "Obriši",
      "action_default_remove": "Ukloni kao zadano",
      "domain_count@@one": "Koristi {{count}} domena",
      "domain_count@@other": "Koristi ih {{count}} domena"
    },
    "paypal_bind": {
      "button": "Poveži PayPal račun",
      "button_load": "Povezivanje…",
      "disconnected": "Nije povezano",
      "success": "Vaš PayPal račun je sada povezan, s vašeg sljedećeg računa će biti oduzetih $5!",
      "success_no_promo": "Vaš PayPal račun je sada povezan",
      "error": "Došlo je do greške",
      "success_header": "Uspjeh"
    },
    "card_add": {
      "header": "Dodaj novu karticu",
      "success": "Nova kartica je povezana s Linguise!",
      "terms": "Davanjem podataka o kartici, dopuštate Linguise da naplati vašu karticu za buduća plaćanja prema našim uvjetima korištenja."
    },
    "card_detail": {
      "header": "Podaci o kartici",
      "delete": {
        "error": "Ne možete obrisati ovaj način plaćanja jer ima aktivne pretplate!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Pretplate na ovaj način plaćanja",
        "header_domain": "Domena",
        "header_plan": "Plan",
        "header_status": "Status",
        "header_actions": "Radnje",
        "cancelling": "Otkaže se: {{0}}",
        "next_payment": "Sljedeće plaćanje: {{0}}",
        "action_renew": "Obnovi",
        "no_subs_header": "Nema pretplata za prikaz",
        "no_subs_desc": "Kada se pretplata napravi na ovu karticu, sve informacije će biti prikazane ovdje",
        "action_manage": "Upravljaj"
      },
      "status": {
        "active": "Aktivna",
        "canceled": "Otkazana",
        "incomplete": "Neplaćena",
        "incomplete_expired": "Neplaćena (Istekla)",
        "missing": "Greška",
        "past_due": "U kašnjenju",
        "trialing": "Probna",
        "unpaid": "Neplaćena"
      }
    },
    "delete_confirm_body": "Jeste li sigurni da želite izbrisati ovaj način plaćanja? Ova radnja se ne može poništiti!",
    "delete_confirm_header": "Izbrisati način plaćanja?",
    "card_edit": {
      "header": "Uredi karticu",
      "billing_header": "Podaci za naplatu",
      "address_error": "Adresa je obavezna!",
      "card_number": "Broj kartice",
      "card_expiry": "Datum isteka",
      "expiry_error_month": "Nevažeći mjesec",
      "expiry_error_year": "Nevažeća godina",
      "expiry_error_expired": "Godina isteka vaše kartice je u prošlosti.",
      "card_header": "Informacije o kartici",
      "expiry_error_empty": "Ovo polje je obavezno!"
    }
  },
  "plans": {
    "per": "po",
    "wordsTranslated": "riječi prevedeno",
    "current": "Trenutno",
    "archived": "Arhivirano",
    "day": "dan",
    "week": "tjedan",
    "month": "mjesec",
    "year": "godina",
    "activate": "Aktiviraj",
    "cancel": "Otkaži",
    "change": "Promijeni",
    "upgrade": "Nadogradi",
    "downgrade": "Smanji",
    "resume": "Nastavi",
    "notEnoughWords": "Nema dovoljno riječi",
    "yearIntervalOnly": "Nemoguće je migrirati s godišnjeg plana",
    "subsCanceled": "U tijeku je otkazivanje druge pretplate",
    "wordsUnlimited": "Neograničen broj riječi",
    "tabs": {
      "day": "Dnevne cijene",
      "week": "Tjedne cijene",
      "month": "Mjesečne cijene",
      "year": "Godišnje cijene",
      "sub_texts": {
        "day": "Jedna fiksna cijena, svaki dan",
        "week": "Jedna fiksna cijena, svaki tjedan",
        "month": "Jedna fiksna cijena, svaki mjesec",
        "year": "Jedan mjesec gratis, jedan račun godišnje"
      }
    },
    "details": {
      "new_languages": "Dodajte nove jezike u bilo kojem trenutku",
      "one_month_trial": "Jednomjesečni besplatni probni period za svaku novu web stranicu",
      "multi_content_indexed": "100 % višejezičnog sadržaja indeksirano",
      "translate_new_content": "Prevedite novi sadržaj odmah",
      "free_installation": "Besplatna instalacija i postavljanje",
      "compared_monthly_plan": "Jedan mjesec gratis u usporedbi s mjesečnim planovima",
      "risk_free_recurring": "Bez rizika pri neuspjelom ponavljajućem plaćanju",
      "unlimited_languages": "Neograničeni jezici i pregledavanja stranica",
      "high_server_resources": "Visoki server resursi",
      "billed": {
        "day": "Naplaćuje se dnevno",
        "week": "Naplaćuje se tjedno",
        "month": "Naplaćuje se mjesečno",
        "year": "Naplaćuje se godišnje"
      },
      "request_max_size": "{{0}} maksimalna veličina zahtjeva"
    },
    "frequent_question": {
      "title": "Česta pitanja",
      "questions": {
        "trial": {
          "question": "Mogu li koristiti probni period na novom domeni web stranice?",
          "answer": "Da, nudimo 30‑dnevni besplatni probni period za svaku novu domenu web stranice koju dodate na svoj račun. Na taj način možete potpuno testirati uslugu prevođenja na novoj web stranici."
        },
        "seo": {
          "question": "Koliko vremena treba da se moj SEO poboljša?",
          "answer": "Sadržaj, a posebno višejezični sadržaj, trebaju vrijeme da budu u potpunosti indeksirani i dobro rangirani. Ovisno o prometu i veličini vaše web stranice, to traje između 3 i 6 tjedna."
        },
        "quota": {
          "question": "Jesu li ljudski prijevodi uključeni u kvotu?",
          "answer": "Ne, limit broja riječi odnosi se samo na automatske strojne prijevode. Prevoditelj može ručno uređivati automatske prijevode bez ograničenja."
        }
      }
    },
    "best_offer": "Najbolja ponuda",
    "period": {
      "days@@one": "dan",
      "days@@other": "{{count}} dana",
      "hours@@one": "sat",
      "hours@@other": "{{count}} sati",
      "minutes@@one": "minuta",
      "minutes@@other": "{{count}} minuta",
      "seconds@@one": "sekunda",
      "seconds@@other": "{{count}} sekundi"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "{{words}} riječi po {{period}}"
  },
  "profile": {
    "welcome": "Dobrodošli!",
    "account": "Moj račun",
    "subscriptions": "Pretplate",
    "logout": "Odjava"
  },
  "register": {
    "errors": {
      "password": "Minimum 8 znakova, bilo koji znak"
    }
  },
  "route": {
    "dashboard": "Nadzorna ploča",
    "rules": "Pravila",
    "translations": "Prijevodi",
    "search_translations": "Pretraživanje upita",
    "urls_translations": "Prevođenje URL-ova",
    "links": "Mediji i vanjske poveznice",
    "online_editor": "Uživo uređivač",
    "settings": "Postavke",
    "domain": {
      "finish": "Postavke",
      "preconfig": "Postavke"
    },
    "home": "Početna",
    "domain_list": "Popis domena",
    "members": "Članovi",
    "invoices": "Računi",
    "billing": "Podaci o naplati",
    "language_display": "Prikaz zastavica jezika",
    "payment_methods": "Načini plaćanja",
    "ai_translation": "AI prijevod",
    "ai_translation_settings": "Postavke",
    "ai_translation_pricing": "Cijene"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Tekst za ignoriranje",
        "add": "Dodaj novo",
        "title": "Tekst za ignoriranje",
        "description": "Dodajte jedan ili više tekstova za ignoriranje",
        "ignore_case": "Zanemari velika/mala slova"
      },
      "html_content": {
        "title": "Primijeni na HTML sadržaj",
        "description": "Primijenite pravilo na cijeli sadržaj ili odabirom određenog CSS selektora",
        "all_page": "Cijela stranica",
        "css_selector": "CSS selektor",
        "label": "CSS selektor",
        "placeholder": "Selektor za primjenu",
        "add": "Dodaj novo"
      },
      "apply_to_urls": {
        "title": "Primijeni na URL‑ove",
        "description": "Odaberite određene URL‑ove na koje želite primijeniti pravilo",
        "all_urls": "Svi URL‑ovi",
        "selected_urls": "Odabrani URL‑ovi",
        "label": "URL za primjenu",
        "placeholder": "URL za primjenu",
        "original_url": "Izvorni URL‑ovi",
        "translated_url": "Prevedeni URL",
        "wildcard": "Zamjenski znak",
        "regex": "Regularni izraz",
        "add": "Dodaj novo",
        "expression": "Tip izraza"
      },
      "apply_urls": {
        "title_exclude": "Isključi u URL‑ovima",
        "title_replace": "Zamijeni u URL‑ovima",
        "title_description": "Također primijeni ovo pravilo na prevođenje URL‑ova"
      },
      "apply_languages": {
        "title": "Primijeni na jezike",
        "description": "Odaberite određeni jezik na koji želite primijeniti pravilo",
        "all_languages": "Svi jezici",
        "selected_languages": "Odabrani jezici",
        "placeholder": "Odaberite jezike...",
        "feedback": "Morate odabrati jezik"
      },
      "name": {
        "title": "Naslov",
        "description": "Dajte svom pravilu naslov radi praktičnosti",
        "placeholder": "Naziv pravila"
      },
      "type": {
        "title": "Tip",
        "description": "Odaberite tip pravila koje želite dodati",
        "text_ignore": "Zanemarivanje teksta",
        "text_replace": "Zamjena teksta",
        "content_exclusion": "Isključenje sadržaja",
        "url_exclusion": "Isključenje po URL‑u",
        "ignore_inline": "Zanemari inline",
        "full_description": {
          "text_ignore": "Dodajte pravila za izbjegavanje prevođenja određenog teksta. To može biti naziv vašeg proizvoda, brenda ili drugi tehnički elementi koje ne želite prevesti.",
          "text_replace": "Zamjena teksta omogućuje zamjenu nekog teksta željenim prijevodom, što može biti potrebno kada prijevod zanemaruje kontekst.",
          "content_exclusion": "Isključenje sadržaja pomoći će vam da izbjegnete prevođenje određenog dijela stranice.\nAko želite potpuno isključiti stranicu iz prevođenja (bez višejezičnog URL‑a i bez prevedenog sadržaja), upotrijebite tip \"Isključenje po URL‑u\"",
          "url_exclusion": "Isključenje prijevoda stranice pomoći će vam postaviti stranice koje ne želite prevesti.",
          "ignore_inline": "Izbjegavajte prevođenje nekog sadržaja kao inline sadržaja, umjesto toga prevedite svaki element zasebno."
        }
      },
      "text_replace": {
        "title": "Tekst za zamjenu",
        "description": "Zamijenite određeni tekst svojim specifičnim prijevodom. Zamijenite bilo koji tekst na svim svojim stranicama, po jeziku…",
        "text_to_replace": "Tekst za zamjenu",
        "ignore_case": "Zanemari veličinu slova",
        "text_type": "Zamjena u prijevodu",
        "text_type_original": "Original",
        "text_type_translation": "Prijevod",
        "keep_case": "Pokušaj zadržati veličinu slova",
        "add": "Dodaj novo"
      },
      "content_exclusion": {
        "title": "Isključenje sadržaja",
        "description": "Odaberite jedan ili više CSS selektora koji se neće prevoditi",
        "label": "CSS selektor",
        "placeholder": "Selektor za primjenu",
        "add": "Dodaj novo"
      },
      "multilingual_url": {
        "title": "Koristi višejezični URL",
        "description": "Ako je postavljeno na Da, URL se NE PREVODI, ali stranica ostaje višejezična s prevedenim sadržajem",
        "live_example_title": "Živi primjer",
        "live_example_description": "Izvorni URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Generirani URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Generirani URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Primijeni pravilo na statički ili dinamički sadržaj, ili na oba",
        "title": "Primijeni na sadržaj",
        "all": "Sav sadržaj",
        "static": "Statički sadržaj",
        "dynamic": "Dinamički sadržaj"
      },
      "force_apply_urls": {
        "title_description": "Prisilno primijeni ovo pravilo na sve prijevode URL‑ova, uključujući postojeće prijevode!",
        "title_replace": "Prisilna zamjena u URL‑ovima",
        "title_exclude": "Prisilno isključenje u URL‑ovima",
        "warning": "Upozorenje",
        "warning_part1": "Postavljanje na \"Da\" može oštetiti prijevode URL‑ova vaše web‑stranice.",
        "warning_part2": "To može privremeno ili trajno generirati stranicu 404, nastavite samo ako razumijete posljedice.",
        "warning_replacement_original": "Dodatno upozorenje: Pokušavate zamijeniti originalni sadržaj koji može utjecati na URL, prijevod može neuspjeti jer Linguise ne može pravilno pronaći originalne URL‑ove"
      }
    },
    "main": {
      "parent": "Pravila",
      "edit": "Uredi pravilo",
      "add": "Novo pravilo"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" bit će zanemaren u sadržaju i u URL‑u",
      "preview_single": "\"{{text_ignore}}\" bit će zanemaren u sadržaju",
      "preview_more_with_url": "\"{{text_ignore}}\" i {{count}} dodatna će biti zanemarena u sadržaju",
      "preview_more": "\"{{text_ignore}}\" i {{count}} dodatna će biti zanemarena u sadržaju",
      "other_parameters": "Za ovo pravilo su postavljeni drugi parametri, kliknite gumb za uređivanje za više informacija"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" se zamjenjuje s \"{{replacement}}\" u sadržaju i URL‑ovima",
      "preview_single": "\"{{original}}\" se zamjenjuje s \"{{replacement}}\" u sadržaju",
      "preview_more_with_url": "\"{{original}}\" se zamjenjuje s \"{{replacement}}\" u sadržaju i URL‑ovima, i {{nb}} dodatna",
      "preview_more": "\"{{original}}\" se zamjenjuje s \"{{replacement}}\" u sadržaju, i {{nb}} dodatna",
      "other_parameters": "Za ovo pravilo su postavljeni drugi parametri, kliknite gumb za uređivanje za više informacija"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS selektor(a) isključen(i) iz prevođenja",
      "other_parameters": "Za ovo pravilo su postavljeni drugi parametri, kliknite gumb za uređivanje za više informacija"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL‑a su isključeni iz prevođenja, ali zadržavaju višejezični prefiks",
      "some": "{{nb}} URL‑a su potpuno isključeni iz prevođenja",
      "all_multilingual": "svi URL‑ovi su isključeni iz prevođenja, ali zadržavaju višejezični prefiks",
      "all": "svi URL‑ovi su potpuno isključeni iz prevođenja",
      "other_parameters": "Za ovo pravilo su postavljeni drugi parametri, kliknite gumb za uređivanje za više informacija"
    },
    "ignore_inline": {
      "elements": "Sav inline sadržaj bit će preveden kao blok‑sadržaj na stranici",
      "all_elements": "Neki inline sadržaj bit će preveden kao blok‑sadržaj na stranici",
      "other_parameters": "Za ovo pravilo postavljeni su i drugi parametri, kliknite gumb za uređivanje da biste dobili više informacija"
    },
    "title": "Upravljanje pravilima",
    "description": "Upravljajte isključenjima i zamjenama sadržaja vašeg prijevoda diljem web‑stranice",
    "add": "Dodaj novo pravilo",
    "table": {
      "title": "Naslov",
      "no_data": "Još nema pravila",
      "type": "Tip",
      "preview": "Pregled pravila",
      "action": "Radnja",
      "delete_confirm": "Potvrdite brisanje pravila",
      "types": {
        "text_ignore": "Zanemari tekst",
        "text_replace": "Zamijeni tekst",
        "content_exclusion": "Isključenje sadržaja",
        "url_exclusion": "Isključenje URL‑a",
        "ignore_inline": "Zanemari inline",
        "unknown": "Nepoznata pravila"
      }
    },
    "apply_on_content": {
      "static": "Ovo pravilo će se primjenjivati ​​samo na statički sadržaj",
      "dynamic": "Ovo pravilo će se primjenjivati ​​samo na dinamički sadržaj"
    }
  },
  "search_translations": {
    "title": "Upravljanje upitima pretraživanja",
    "description": "Popis svih prijevoda vaše web‑stranice korištenih putem obrazaca pretraživanja (od prevedenog jezika do osnovnog jezika vaše domene)",
    "filter_languages": "Filtriraj po jezicima...",
    "filter_original": "Filtriraj tekst na izvornoj jeziku",
    "filter_translation": "Filtriraj po prevedenom tekstu",
    "table": {
      "original": "Izvorni",
      "language": "Jezik",
      "translation": "Prijevod"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Neuspjela pretplata!",
      "title": "Neuspjela pretplata!",
      "subtitle": "Došlo je do pogreške prilikom obrade vaše pretplate.",
      "home": "Vrati se na početak",
      "generic": "Došlo je do nepoznate pogreške na strani Linguise, kontaktirajte administratora!"
    },
    "success": {
      "home": "Upravljajte prijevodima domene",
      "message": "Posvećeni smo pružanju najboljeg mogućeg iskustva prevođenja. Naš tim stručnjaka stoji vam na raspolaganju za sva pitanja i podršku. Za početak, jednostavno kliknite na gumb ispod.",
      "subtitle": "Hvala što ste odabrali uslugu prevođenja Linguise",
      "title": "Pretplata aktivirana!",
      "tab_title": "Hvala na pretplati!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Pretplata aktivirana!",
      "title": "Pretplata aktivirana!",
      "subtitle": "Hvala što ste odabrali uslugu prevođenja Linguise",
      "message": "'Posvećeni smo pružanju najboljeg mogućeg iskustva prevođenja. Naš tim stručnjaka stoji vam na raspolaganju za sva pitanja i podršku. Za početak, jednostavno kliknite na gumb ispod. ",
      "home": "Upravljajte prijevodima domene"
    },
    "edit": {
      "title": "Upravljanje pretplatom"
    },
    "list": {
      "title": "Popis pretplata",
      "description": "Popis pretplata vaše domene"
    },
    "table": {
      "domain": "Domena",
      "plan": "Plan",
      "status": "Status",
      "card": "Kartica",
      "usage": "Uporaba",
      "actions": "Radnje",
      "payment_method": "Način plaćanja"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} riječi",
      "paidOffered": "{{words_used}} / {{words_allowed}} riječi\n(Uključeno {{free_words}} besplatnih riječi)"
    },
    "popup": {
      "dueToday": "Ukupno dospjelo danas",
      "nextPeriod": "Počevši od {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Odaberite račun"
    }
  },
  "translation": {
    "main": {
      "parent": "Prijevodi",
      "edit": "Uredi prijevod"
    },
    "form": {
      "original": {
        "title": "Izvorni na {{language}}"
      },
      "is_inline": "Ovaj prijevod je napravljen iz inline sadržaja.",
      "inline_editor": {
        "count_warning": "Broj umetnutih područja ne podudara se s izvornikom ({{current}} od {{expected}}).",
        "restore_original": "Vrati izvorni tekst",
        "insert_placeholder": "Umetni rezervirano mjesto",
        "drag": "Povucite za promjenu redoslijeda područja",
        "area": "Inline područje {{index}}",
        "restore": "Vrati područja koja nedostaju"
      },
      "translation": {
        "title": "Prijevod na {{language}}",
        "description": "Prijevod koji želite zamijeniti"
      }
    },
    "copy": {
      "title": "Kopiraj u ručni prijevod",
      "label": "Kopiraj u ručni"
    },
    "level": {
      "base": {
        "title": "Osnovni prijevod",
        "subtitle": "Automatski · Linguise Cloud prijevod",
        "empty": "Nema osnovnog prijevoda za ovaj tekst.",
        "overridden": "Vaš odabir je spremljen, ali se umjesto njega prikazuje najnoviji AI poboljšani prijevod jer je „Nadjačaj ručne i odabrane prijevode” postavljeno na Da u postavkama AI prijevoda. Isključite tu postavku da biste koristili svoj odabir."
      },
      "not_generated": "Nije generiran",
      "none": "Još ništa",
      "ai": {
        "title": "AI poboljšani prijevod",
        "subtitle": "Automatski · Linguise AI",
        "empty_title": "Još nije generiran za ovaj tekst",
        "empty_description": "Linguise AI daje prirodnije prijevode koristeći kontekst vaše stranice i web stranice. Da biste ga dobili ovdje:",
        "empty_step_1": "Idite na AI prijevod › Postavke i postavite Omogući AI prijevod na „Samo pravila”, „Samo live editor” ili „Pravila i live editor”.",
        "empty_step_2": "Primijenite ga pravilom koje odgovara ovoj stranici ili ga omogućite stranicu po stranicu iz live editora.",
        "empty_step_3": "AI poboljšani prijevod pojavit će se ovdje čim se generira. Troši vaše AI kredite.",
        "open_settings": "Otvori postavke AI prijevoda",
        "open_editor": "Otvori live editor",
        "overrides_selection": "Vaš odabir je spremljen, ali se umjesto njega prikazuje ovaj AI poboljšani prijevod jer je „Nadjačaj ručne i odabrane prijevode” postavljeno na Da u postavkama AI prijevoda. Isključite tu postavku da biste koristili svoj odabir.",
        "overrides_version": "Verzija koju ste odabrali je spremljena, ali se umjesto nje prikazuje najnovija AI poboljšana verzija jer je „Nadjačaj ručne i odabrane prijevode” postavljeno na Da u postavkama AI prijevoda. Isključite tu postavku da biste koristili odabranu verziju."
      },
      "manual": {
        "title": "Ručni prijevod",
        "subtitle": "Vaš unos · ima prednost pred automatskim prijevodima",
        "empty": "Prazno",
        "saved_but_overridden": "Spremljeno kao vaš izbor, ali se ne prikazuje automatski jer je „Nadjačaj ručne prijevode” postavljeno na Da u postavkama AI prijevoda: AI poboljšani prijevod ima prednost dok se ta postavka ne isključi.",
        "ignored": "Ne prikazuje se automatski jer je „Nadjačaj ručne prijevode” postavljeno na Da u postavkama AI prijevoda. Odaberite ga da ga koristite za ovaj tekst.",
        "label": "Vaš prijevod",
        "placeholder": "Upišite vlastiti prijevod...",
        "last_updated": "Zadnje uređivanje: {{date}}",
        "save_hint": "Spremanjem ručnog prijevoda on postaje aktivan.",
        "delete": "Izbriši ručni prijevod",
        "delete_confirm": "Molimo potvrdite brisanje ručnog prijevoda"
      }
    },
    "history": {
      "title": "AI poboljšane verzije",
      "subtitle": "Svako ponovno generiranje iz live editora se čuva",
      "unknown_model": "Nepoznati model",
      "current": "Trenutna",
      "restore": "Vrati ovu verziju",
      "restore_note": "Vraćanjem ta verzija postaje trenutni AI poboljšani prijevod. Ništa se ne briše.",
      "version_of": "Verzija {{current}} od {{total}}",
      "hide": "Sakrij povijest ({{total}})",
      "show": "Prikaži povijest ({{total}})"
    },
    "choose": {
      "title": "Prijevodi na jeziku {{language}} · odaberite onaj koji posjetitelji vide",
      "current": "Trenutno na vašoj web stranici:",
      "priority": "Zadani prioritet: ručni › AI poboljšani › osnovni. Vaš izbor se sprema samo za ovaj prijevod.",
      "reset": "Vrati na zadani prioritet",
      "reset_title": "Zaboravi odabir za ovaj tekst i ponovno koristi zadani prioritet",
      "resetting": "Vraćanje ..."
    }
  },
  "translations": {
    "title": "Upravljanje prijevodima",
    "description": "Popis i uređivanje svih prijevoda vaše web‑stranice, za vizualni prijevod koristite Live Editor",
    "filter_languages": "Filtriraj po jezicima...",
    "filter_original": "Filtriraj tekst na izvornoj jeziku",
    "filter_translation": "Filtriraj po prevedenom tekstu",
    "table": {
      "original": "Izvorni",
      "language": "Jezik",
      "action": "Radnja",
      "base": "Osnovni",
      "ai": "AI poboljšani",
      "manual": "Ručni"
    },
    "filter_exact": "Točan podudar",
    "badge": {
      "active": "Aktivno",
      "overrides_manual": "Nadjačava ručni"
    },
    "cell": {
      "none": "nema",
      "not_generated": "nije generiran",
      "ignored": "Zanemaren – AI pravilo ima prednost"
    },
    "tabs": {
      "all": "Svi",
      "manual": "S ručnim",
      "ai": "S AI poboljšanim",
      "base": "Samo osnovni"
    },
    "levels_hint": "Svaki tekst ima do 3 razine — ona označena kao Aktivno je ona koju vide posjetitelji."
  },
  "url": {
    "main": {
      "parent": "URL‑ovi",
      "edit": "Uredi URL prijevod"
    },
    "form": {
      "original": {
        "title": "Izvorni na {{language}}"
      },
      "translation": {
        "title": "URL prijevod na {{language}}",
        "description": "URL koji želite zamijeniti",
        "placeholder": "Zamjena URL‑a",
        "invalid_full": "Pokušavate promijeniti s neispravnim formatom, trebate mijenjati samo slugove/putanju URL‑a",
        "invalid": "Neispravan URL/put pružen"
      }
    }
  },
  "urls": {
    "title": "Upravljanje URL‑ovima",
    "description": "Popis i uređivanje svih prevedenih URL‑ova vaše web‑stranice (napredno, pripazite na 404 greške)",
    "filter_languages": "Filtriraj po jezicima...",
    "filter_original": "Filtriraj tekst na izvornoj jeziku",
    "filter_translation": "Filtriraj po prevedenom tekstu",
    "table": {
      "original": "Izvorni",
      "language": "Jezik",
      "url": "Prevedeni URL",
      "action": "Radnja",
      "edited": "Izvorni prijevod je izmijenjen"
    }
  }
}
